import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var BusSideOutlineSVG = function BusSideOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29,5H3A2,2,0,0,0,1,7V22a2,2,0,0,0,2,2H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a2,2,0,0,0,2-2V7A2,2,0,0,0,29,5ZM21,7h8a0,0,0,0,1,0,0v6H21ZM3,7A0,0,0,0,1,3,7H19v6H3ZM9,25a2,2,0,1,1,2-2A2,2,0,0,1,9,25Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,25Zm6-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H3s0-7,0-7H29S29,22,29,22Z"
  }));
};
BusSideOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BusSideOutlineSVG);